<template>
    <div class="min-h-screen">
        <div class="max-w-full mx-auto">
            <!-- Header -->
            <div class="mb-6">
                <h1 class="text-3xl font-bold text-gray-900 flex items-center">
                    <i class="bx bx-wallet text-blue-600 mr-3 text-4xl"></i>
                    Agent Deposit
                </h1>
                <p class="text-sm text-gray-600 mt-2">Make deposits for Chapman Xpress agents</p>
            </div>

            <!-- Deposit Form -->
            <CXDeposit :user="user" />
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import CXDeposit from './Types/CXDeposit';

export default {
    middleware: 'auth',
    layout: 'default',
    
    components: {
        CXDeposit,
    },

    data: () => ({
        isLoading: false,
    }),

    computed: mapGetters({
        user: 'auth/user',
    }),

    mounted() {
        if (this.user.data.worksheet_status) {
            this.$router.go(-1);
            Swal.fire({
                icon: 'warning',
                title: 'Worksheet already generated!',
                text: 'Please note that after generating a worksheet you are not allowed to make sales',
            });
            return false;
        }
    },

    methods: {},
};
</script>
